<div class="card-skeleton">
  <div class="skeleton-poster">
    <div class="skeleton-shimmer-wrap">
      <div class="skeleton-shimmer"></div>
    </div>
    <div class="skeleton-circle" *ngIf="mediaType !== 'person'"></div>
    <div class="skeleton-badge" *ngIf="mediaType === 'person'"></div>
  </div>
  <div class="skeleton-content">
    <div class="skeleton-line skeleton-title"></div>
    <div class="skeleton-line skeleton-meta"></div>
  </div>
</div>
